import { Injectable } from '@angular/core';
import { Offer, Product, ProductAvailability } from 'src/app/models/verylys';
import { AbstractService, PaginationResult } from '../abstract/abstract.service';
import { VlApiService } from '../vl-api/vl-api.service';
import { orderBy, sortBy } from 'lodash';
import { Observable } from 'rxjs';

export enum PRODUCT_TYPE {
    GAME_SERVER = "61a37334f74bd1657b9a1224",
    VOICE_SERVER = "none", // TODO after implementation, not rdy on prod
    VIRTUAL_CURRENCY = "none",// TODO after implementation, not rdy on prod
    CODE = "none"// TODO after implementation, not rdy on prod
}

@Injectable({
    providedIn: 'root'
})

export class ProductService extends AbstractService<Product> {
    route = "/products/";
    resourceReferenceLabel = "Product";
    protected cacheKey: string = "Product";

    protected crudMethods = {
        create: false,
        update: false,
        delete: false,
        get: true,
        getAll: true,
        currency: false,
        country: false
    }

    protected cacheMethods = {
        get: true,
        getAll: true
    }

    public getDetailedList(): Observable<PaginationResult<Product>> {
        return this.vlapi.get<PaginationResult<Product>>(`${this.route}detailed-list`, { cache: true });
    }

    public getDetailed(id: string): Observable<Product> {
        return this.vlapi.get<Product>(`${this.route}${id}/detailed`, { cache: true });
    }

    public seoUrl(product: Product): string {
        return `${product.friendly_id}-${product.parameters?.seo_url?.value}`;
    }

    public isDisplayed(product: Product): boolean {
        if (product.parameters?.availability?.value == ProductAvailability.HIDDEN) {
            return false;
        }

        return true;
    }

    public isOrderable(product: Product): boolean {
        if (product.parameters?.availability?.value == ProductAvailability.NEW) {
            return true;
        }

        if (product.parameters?.availability?.value == ProductAvailability.PREORDER) {
            return true;
        }

        if (product.parameters?.availability?.value == ProductAvailability.AVAILABLE) {
            return true;
        }

        return false;
    }

    /**
     * Get the offers of a product from the object and not from the API
     * 
     * @param product   The product
     * 
     * @returns The offers
     **/
    public getOffersFromObject(product: Product): Offer[] {
        return product?.offers as Offer[];
    }

    /**
     * Get the offer of a product from the object and not from the API
     * 
     * @param product   The product
     * @param offerId   The offer id
     * 
     * @returns The offer
     **/
    public getOfferFromObject(product: Product, offerId: string): Offer {
        return (product?.offers as Offer[])?.find((offer: Offer) => offer._id === offerId);
    }

    public validate(value: Product): void {
        throw new Error($localize`:@@error.method-not-implemented:Method not implemented`);
    }


    /**
     * Get the result by category
     */
    public getProductsByType(results: Product[], type: string): Product[] {
        if (!results?.length) {
            return results;
        }

        const products: Product[] = (results.filter((result: any) => result.type?._id == type));
        return orderBy(products, 'parameters.order.value', 'asc');
    }
}